<template>
  <div id="app">
    <div class="sticky">
      <NavBar />
    </div>
    <router-view></router-view>
    <div id="footer">
        <div id="footer-container" class="flex-grid">
          <div style="float: left" class="column col-6">
            <span style="margin-top: 10px">Designed by</span>
            <a href="https://pattern.broadinstitute.org/" target="_blank">
              <img class="footer-logo" src="./assets/images/pattern.svg" width=150 alt="Pattern logo">
            </a>
            <span style="margin-top: 10px"> for </span>
            <a href="https://depmap.org/portal/" target="_blank">
              <img class="footer-logo" src="./assets/images/depmap.svg" width=140 alt="Depmap logo">
            </a>
          </div>
          <div class="column col-6">
            <a style="float: right" href="https://www.broadinstitute.org/" target="_blank">
              <img class="footer-logo" width=150 src="./assets/images/broad_logo.svg" alt="broad logo">
            </a>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import NavBar from './components/NavBar.vue'
export default {
  name: 'App',
  components: {
    NavBar
  }
}
</script>

<style lang="css" scoped>
#footer {
  margin-top: 100px;
  background-color: #2E3B5E;
  color: white;
  min-height: 120px;
  padding: 0px;
}

#footer-container {
  margin: 0 auto;
  max-width: 1000px;
  padding-top: 30px;
  font-size: 18px;
}

.footer-logo {
  padding-left: 8px;
  padding-right: 8px;
  vertical-align: middle;
}

a[target="_blank"]:after {
  content: none;
  text-decoration: none;
}

a {
  border-bottom: none;
}

a:hover {
  border-bottom: none;
}
</style>
